export class AverageGraphItem {
    public value: number;
    public divider: number;

    constructor(json?: any) {
        if (json) {
            this.value = json.value;
            this.divider = json.divider;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/models/averageGraphItem.ts